"use client";
import React from "react";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const ChatwootWithNoSSR = dynamic(() => import("@/lib/services/chatwoot"), {
  ssr: false,
});

export default function ChatLoader() {
  const isChatOpen = useSelector((state) => state.user.isChatOpen);

  // Only load chat when explicitly opened
  return <>{isChatOpen && <ChatwootWithNoSSR />}</>;
}
